import { refetchMe } from 'actions/me'

export const requestVerify = (token, cancelToken) => (
  (dispatch, getState, api) => api({
    method: 'post',
    apiPath: `actions/query-verify/${token}`,
    cancelToken
  })
)

export const emailVerify = (token, cancelToken) => (
  async (dispatch, getState, api) => {
    await api({
      method: 'post',
      apiPath: `actions/email-verify/${token}`,
      cancelToken
    })
    await dispatch(refetchMe())
  }
)

export const managerEmailVerify = (token, password, cancelToken) => (
  async (dispatch, getState, api) => {
    await api({
      method: 'post',
      apiPath: `actions/manager-email-verify/${token}`,
      data: { password },
      cancelToken
    })
    await dispatch(refetchMe())
  }
)

export const tokenLogin = (token, cancelToken) => (
  async (dispatch, getState, api) => {
    await api({
      method: 'post',
      apiPath: `actions/login/${token}`,
      cancelToken
    })
    await dispatch(refetchMe())
  }
)

export const resetPassword = (token, password, cancelToken) => (
  async (dispatch, getState, api) => {
    await api({
      method: 'post',
      apiPath: `actions/reset-password/${token}`,
      data: { password },
      cancelToken
    })
    await dispatch(refetchMe())
  }
)
